import { useState, useEffect } from 'react';
import { userService } from '../../../services/userService';
import type { UserProfile } from '../../../services/userService';
import type { ApiResponse } from '../../../features/menu/types';

export const useUserProfile = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

    if (!token) {
      setLoading(false);
      return;
    }

    const fetchUser = async () => {
      try {
        const response = await userService.getCurrentUser();
        if (mounted) {
          const userData = response.data as ApiResponse<UserProfile> | UserProfile;
          const userObj: UserProfile =
            'data' in userData && userData.data ? userData.data : (userData as UserProfile);

          setUserProfile({
            Id: userObj.Id,
            Name: userObj.Name,
            Login: userObj.Login,
            Initials: userObj.Initials,
            ProfileUrl: userObj.ProfileUrl,
            ProfileFormKey: userObj.ProfileFormKey,
            CanSeeSensitiveDataPassword: userObj.CanSeeSensitiveDataPassword,
            CanShowProfileNavigation: userObj.CanShowProfileNavigation,
            CanSeeNotifications: userObj.CanSeeNotifications,
            VersionLabel: userObj.VersionLabel,
          });
          setError(null);
        }
      } catch (err: any) {
        if (mounted) {
          setError(err.response?.data?.message || err.message || 'Failed to load user profile');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchUser();

    return () => {
      mounted = false;
    };
  }, []);

  return { userProfile, loading, error };
};
